<div 
  class="relative"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  
  <!-- Dynamic Scrollbar Styles -->
  <style [innerHTML]="scrollbarStyleSheet" [attr.data-theme-trigger]="themeUpdateTrigger()"></style>
  
  <!-- Scroll to Top Button -->
  <button
    *ngIf="showScrollButtons && showScrollTop()"
    (click)="scrollToTop()"
    class="absolute top-2 left-1/2 -translate-x-1/2 z-10 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full p-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500"
    aria-label="Scroll to top">
    <svg class="w-4 h-4 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
    </svg>
  </button>

  <!-- Scroll to Bottom Button -->
  <button
    *ngIf="showScrollButtons && showScrollBottom()"
    (click)="scrollToBottom()"
    class="absolute bottom-2 left-1/2 -translate-x-1/2 z-10 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full p-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500"
    aria-label="Scroll to bottom">
    <svg class="w-4 h-4 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Scroll to Left Button -->
  <button
    *ngIf="showScrollButtons && showScrollLeft()"
    (click)="scrollToLeft()"
    class="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full p-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500"
    aria-label="Scroll to left">
    <svg class="w-4 h-4 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <!-- Scroll to Right Button -->
  <button
    *ngIf="showScrollButtons && showScrollRight()"
    (click)="scrollToRight()"
    class="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full p-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500"
    aria-label="Scroll to right">
    <svg class="w-4 h-4 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
    </svg>
  </button>

  <!-- Scroll Indicator -->
  <div
    *ngIf="showScrollIndicator"
    class="absolute top-0 left-0 right-0 h-1 bg-gray-200 dark:bg-gray-700 z-10">
    <div
      class="h-full transition-all duration-300 bg-blue-600"
      [style.width.%]="scrollPercentage().y">
    </div>
  </div>

  <!-- Scrollable Container -->
  <div
    #scrollContainer
    [class]="'scrollbar-container-' + variant + '-' + size + '-' + visibility + ' ' + containerClasses"
    [ngStyle]="scrollbarStyles"
    [style.max-height]="maxHeight"
    [style.max-width]="maxWidth">
    <ng-content></ng-content>
  </div>
</div>

